// src/utils/systemMessageNotifier.js
let systemMessageHandler = null;

// Flag para ativar/desativar a exibição da mensagem de "Sistema Temporariamente Instável"
// Altere para true quando quiser reativar os avisos de erro 429 na tela.
export const RATE_LIMIT_MESSAGE_ENABLED = false;

export const setSystemMessageHandler = (handler) => {
  systemMessageHandler = handler;
};

export const showRateLimitMessage = () => {
  if (!RATE_LIMIT_MESSAGE_ENABLED) return;

  if (systemMessageHandler) {
    systemMessageHandler();
  } else {
    console.warn(
      "Sistema temporariamente instável. Voltará ao normal em instantes."
    );
  }
};

export const clearSystemMessageHandler = () => {
  systemMessageHandler = null;
};
